import generateRelativeUniqueKey from '@hbrisk/sp3-risk-model-support/utility/random/generateRelativeUniqueKey.js';
import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import AddResponseForm from './AddResponseForm.jsx';
import { EDIT } from '#constants/pathStrings.js';

const STRUCTURAL_RESPONSE_ADD_FORM = 'structuralResponseAdd';

const mapStateToProps = (state, ownProps) => {
  const { modelForm } = ownProps;
  const { isResponseCountGreaterThanMaxForEdp } = modelTypesByForm[modelForm];
  const edpKey = formValueSelector(STRUCTURAL_RESPONSE_ADD_FORM)(state, 'edpKey');
  const canAdd = !isResponseCountGreaterThanMaxForEdp(state, { edpKey });

  return {
    canAdd,
  };
};

const makeOnSubmit = (fields, navigate) => values => {
  const itemKey = generateRelativeUniqueKey();
  fields.unshift({
    edpKey: values.edpKey,
    itemKey,
  });
  navigate(`../${EDIT}/${itemKey}`);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onSubmit: makeOnSubmit(ownProps.fields, ownProps.navigate),
});

const addForm = reduxForm({
  form: STRUCTURAL_RESPONSE_ADD_FORM,
})(AddResponseForm);

const structuralResponseAddForm = pipe(
  connect(mapStateToProps, undefined, mergeProps),
  withNavigate
)(addForm);

export default structuralResponseAddForm;
